import logo from './logo.svg';
import { Inicio } from './pages/Inicio';
import { TopNavBar } from './components/TopNavBar';
import { NavBar } from './components/NavBar';
import { Footer } from './components/Footer';
import { Productos } from './pages/Productos';
import { Navigate, Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import { Contacto } from './pages/Contacto';
import './css/global.module.scss'
import './css/toast.css'
import { Carrito } from './components/Carrito';
import { useState } from 'react';
import { ProveedorContextoGlobal } from './ContextoGlobal';
import { ToastContainer } from 'react-toastify';

function App() {
    const [showCarrito, setShowCarrito] = useState(false);

    const itemsNavBar = [
        { id: 'tab-eventos', nombre: 'Inicio', url: '/' },
        { id: 'tab-productos', nombre: 'Productos', url: '/productos/' },
        { id: 'tab-outlet', nombre: 'Outlet', url: '/outlet/' },
        { id: 'tab-contacto', nombre: 'Contacto', url: '/contacto/' }
    ];

    return (
        <>
            <ProveedorContextoGlobal>
                <TopNavBar />
                <NavBar itemsNavBar={itemsNavBar} setShowCarrito={setShowCarrito} />
                <Carrito show={showCarrito} setShow={setShowCarrito}/>
                <Router >
                    <Routes>
                        <Route path="/" element={<Inicio />} exact />
                        <Route path="/productos" element={<Productos />} exact />
                        <Route path="/outlet" element={<Productos on_sale={true} />} exact />
                        <Route path="/contacto" element={<Contacto />} exact />
                        <Route path="*" element={<Navigate to="/" />} />
                    </Routes>
                </Router>
                <Footer />
                <ToastContainer/>
            </ProveedorContextoGlobal>
        </>
    );
}

export default App;
